module.exports = __webpack_public_path__ + "static/media/ios-git-commit.8aabe86d.svg";